import { render, staticRenderFns } from "./WorkboxUpdates.vue?vue&type=template&id=100b0960&scoped=true&"
import script from "./WorkboxUpdates.vue?vue&type=script&lang=js&"
export * from "./WorkboxUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100b0960",
  null
  
)

export default component.exports